import type { TFunction } from "i18next";
import { z } from "zod";

export const OPERATIONS_DETAILS_MAX_LENGTH = 2000;
export const OPERATIONS_DOCUMENTS_MAX_FILES = 5;

const operationsDocumentSchema = z.object({
  originalFileName: z.string(),
  url: z.string(),
});

export const getOperationsDocumentsSchema = (t: TFunction, label: string) =>
  z
    .array(operationsDocumentSchema)
    .max(
      OPERATIONS_DOCUMENTS_MAX_FILES,
      t("form-validation.max-length", {
        label,
        max: OPERATIONS_DOCUMENTS_MAX_FILES,
      }),
    )
    .optional();

export const getOptionalOperationsCommentsSchema = (t: TFunction, label: string) =>
  z
    .string()
    .max(
      OPERATIONS_DETAILS_MAX_LENGTH,
      t("form-validation.max-length", {
        label,
        max: OPERATIONS_DETAILS_MAX_LENGTH,
      }),
    )
    .optional();

export const getRequiredOperationsReasonSchema = (t: TFunction, label: string) =>
  z
    .string()
    .trim()
    .min(
      1,
      t("form-validation.mandatory", {
        label,
      }),
    )
    .max(
      OPERATIONS_DETAILS_MAX_LENGTH,
      t("form-validation.max-length", {
        label,
        max: OPERATIONS_DETAILS_MAX_LENGTH,
      }),
    )
    .optional();
